import { call, put, takeLatest, all } from "redux-saga/effects";
import { toastr } from "react-redux-toastr";
import { push } from "react-router-redux";
import { delay } from "../../utility/commonHelpers";
import { showAlert } from "../../utility/alertHelper";

import {
  SUBSCRIBE_PLAN,
  SUBSCRIBE_PLAN_SUCCEDED,
  SUBSCRIBE_PLAN_FAILED,
  RATE_CARD,
  RATE_CARD_SUCCEDED,
  RATE_CARD_FAILED,
  PLAN_SIZE_CHANGE,
  CHECK_OUT_PAYMENT,
  CHECK_OUT_PAYMENT_SUCCEDED,
  CHECK_OUT_PAYMENT_FAILED,
  PAYMENT_WEBHOOK,
  PAYMENT_WEBHOOK_SUCCEEDED,
  PAYMENT_WEBHOOK_FAILED,
  USER_CURRENT_PLAN,
  USER_CURRENT_PLAN_SUCCEDED,
  USER_CURRENT_PLAN_FAILED,
  CLOSE_CART,
  GLOBAL_AVAILABLE_CREDITS,
} from "../../common/constants";

import * as api from "../../services/pricing";
// import history from "../../utility/history";
// function* loginSaga() {

//Worker saga
function* subscribePlan(action) {
  try {
    const subscriplanResult = yield call(api.subscripePlan, action.subscribePlanInfo);

    //Write redirection logic here
    // const result = JSON.parse(loginResult);
    if (subscriplanResult.success) {
      yield put({
        type: SUBSCRIBE_PLAN_SUCCEDED,
        subscribePlanInfo: action.subscribePlanInfo,
      });
      yield put(push("/email-verification"));
    } else {
      showAlert(subscriplanResult.msg);

      yield put({
        type: SUBSCRIBE_PLAN_FAILED,
        args: {
          message: subscriplanResult.msg,
        },
      });
    }
  } catch (error) {
    toastr.error("Error", error.msg | "Login Failed", {
      timeOut: 0,
      extendedTimeOut: 0,
    });
    yield put({
      type: SUBSCRIBE_PLAN_FAILED,
      args: {
        message: error.message,
      },
    });
  }
}

//Worker saga
function* getRateCards() {
  try {
    const ratecardResult = yield call(api.getRateCards);
    if (ratecardResult.Plans != undefined) {
      yield put({
        type: RATE_CARD_SUCCEDED,
        ratecardList: ratecardResult,
      });
      yield put({
        type: PLAN_SIZE_CHANGE,
        ratecardList: ratecardResult,
        size:
          ratecardResult.PlanSizes.indexOf("5000") !== -1
            ? ratecardResult.PlanSizes[ratecardResult.PlanSizes.indexOf("5000")]
            : ratecardResult.PlanSizes[1],
      });
    } else {
      showAlert(ratecardResult.msg);

      yield put({
        type: RATE_CARD_FAILED,
        args: {
          message: ratecardResult.msg,
        },
      });
    }
  } catch (error) {
    toastr.error("Error", error.msg | "Rate cards fetching failed", {
      timeOut: 0,
      extendedTimeOut: 0,
    });
    yield put({
      type: RATE_CARD_FAILED,
      args: {
        message: error.message,
      },
    });
  }
}

//Worker saga
function* checkOutPayment(action) {
  try {
    // console.log("checkOutPayment saga worker:" + JSON.stringify(action));
    const result = yield call(api.checkOutPayment, action.invoiceData);
    // console.log("checkOutPayment result:" + JSON.stringify(result));
    //debugger;
    if (result.key_token.length > 0) {
      yield put({
        type: CHECK_OUT_PAYMENT_SUCCEDED,
        invoiceInfo: result,
      });
      // yield put(push("/dashboard"));
    } else {
    }
  } catch (error) {
    yield put({
      type: CHECK_OUT_PAYMENT_FAILED,
      args: {
        message: error.message,
      },
    });
  }
}

//Worker saga
function* paymentWebhook(action) {
  try {
    let paymentDetails = JSON.parse(action.paymentDetails);
    paymentDetails.invoiceInfo = action.invoiceInfo.key_token;
    const result = yield call(api.paymentWebhook, paymentDetails);

    if (result.success) {
      yield delay(5000);
      yield put({
        type: PAYMENT_WEBHOOK_SUCCEEDED,
      });
      //setTimeout(function () {
      yield put(push("/dashboard"));
      // }
      //     , 5000);
    } else {
      yield put({
        type: GLOBAL_AVAILABLE_CREDITS,
        available_credits: action.available_credits,
      });
      yield put({
        type: PAYMENT_WEBHOOK_SUCCEEDED,
      });
    }
  } catch (error) {
    yield put({
      type: PAYMENT_WEBHOOK_FAILED,
      args: {
        message: error.message,
      },
    });
  }
}

//Worker saga
function* getUserCurrentPlan(action) {
  try {
    // console.log("getUserCurrentPlan saga worker:" + JSON.stringify(action));
    const result = yield call(api.getUserCurrentPlan, action.mmCustomerID);
    // console.log("getUserCurrentPlan result:" + JSON.stringify(result));
    //debugger;
    if (result) {
      yield put({
        type: USER_CURRENT_PLAN_SUCCEDED,
        userCurrentPlan: result,
      });
    } else {
    }
  } catch (error) {
    yield put({
      type: USER_CURRENT_PLAN_FAILED,
      args: {
        message: error.message,
      },
    });
  }
}

// listener Saga
function* onsubscribePlan() {
  yield takeLatest(SUBSCRIBE_PLAN, subscribePlan);
}

// listener Saga
function* ongetRateCards() {
  yield takeLatest(RATE_CARD, getRateCards);
}

function* oncheckOutPayment() {
  yield takeLatest(CHECK_OUT_PAYMENT, checkOutPayment);
}

function* onpaymentWebhook() {
  yield takeLatest(PAYMENT_WEBHOOK, paymentWebhook);
}

function* ongetUserCurrentPlan() {
  yield takeLatest(USER_CURRENT_PLAN, getUserCurrentPlan);
}

export default function* pricingSaga() {
  yield [ongetRateCards(), oncheckOutPayment(), onpaymentWebhook(), ongetUserCurrentPlan()];
}



// WEBPACK FOOTER //
// ./src/Containers/Pricing/sagas.js